<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
	  console.log(matched,'matchedmatched1');
	  let f1 = matched.find(f=>f.meta.title == '用户')
	  if(f1 != undefined){
		  f1.meta.title = this.$t('h.vip.yonghu')
	  }
	  let f2 = matched.find(f=>f.meta.title == '会员管理')
	  if(f2 != undefined){
	  		  f2.meta.title = this.$t('h.vip.huiyuanguanli')
	  }
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: this.$t('h.navbar.home') }}].concat(matched)
      }
			console.log(matched,'matchedmatched2');
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    box-shadow: 0px 3px 6px rgba(96, 96, 96, 0.16);
    background: #FFFFFF;
    border-radius: 5px;
    padding: 9px 20px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue